import React, { useCallback } from "react";
import useGetBuildSpinnerFrame from "../../../../hooks/shared/spin/useGetBuildSpinnerFrame";
import { BnbLabel, useBnbOptionalLabel } from "../../../../utils/labels";
import { useBnbSelector } from "../../../../redux/store";
import { generateImageSet } from "../../../../utils/typedUtils";
import PaymentDetails from "../../common/PaymentDetails";
import { NavStep } from "../../../../../shared-logic/utils/Navigation";
import BasketHeader from "../../common/basket/content/BasketHeader";
import * as Image from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Image";
import * as Text from "../../../../../../../common-deprecated/styles/v2/lexus/utilities/Text";
import * as Styles from "./styles/Reserve";
import { IconArrowLeftLong } from "../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import ButtonPrimary from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonPrimary";
import ButtonWithIcon from "../../../../../../../common-deprecated/components/aem/lexus/button/ButtonWithIcon";
import useStepUrl from "../../../../hooks/shared/actions/useStepUrl";

type PropsType = {
    reserveCar: () => void;
};

const ReservePanel = (props: PropsType): JSX.Element => {
    const { reserveCar } = props;
    const { model, grade } = useBnbSelector((state) => state.car);
    const { colour } = useBnbSelector((state) => state.basket);
    const financeOption = useBnbSelector((state) => state.utils.financeOption);
    const [genericePriceDisclaimerReserve, reserveNowLabel, reserveNowMonthlyLabel] = useBnbOptionalLabel([
        "genericPriceDisclaimerReserve",
        "reserveReserveNow",
        "reserveReserveNowMonthly",
    ]);
    const reserveLabel =
        financeOption === "monthly" && reserveNowMonthlyLabel
            ? "reserveReserveNowMonthly"
            : reserveNowLabel
              ? "reserveReserveNow"
              : null;

    const summaryStep = useStepUrl(NavStep.Summary, undefined, true);

    const { getImage, cacheKey } = useGetBuildSpinnerFrame(false);
    const getFrame = useCallback(() => {
        return generateImageSet(
            (width: number, height: number) => getImage(width, height, 2, { bgColour: "", padding: 0 }),
            800,
            460,
        ); // same size as mobile basket
    }, [cacheKey]);

    return (
        <Styles.Panel>
            <Styles.ImageWrapper>
                <Image.ImageFluid
                    src={getFrame().src}
                    srcSet={getFrame().srcset}
                    sizes=""
                    draggable={false}
                    alt={`${model.name} ${grade.name} ${colour.name}`}
                />
            </Styles.ImageWrapper>
            <Styles.BasketTitle>
                <BnbLabel label="basketYourModel" params={{ name: model.webtitleSectionName }} />
            </Styles.BasketTitle>

            <BasketHeader />
            <PaymentDetails cashPriceDisclaimer={genericePriceDisclaimerReserve} />

            <Styles.ButtonWrapper>
                {reserveLabel && (
                    <ButtonPrimary onClick={reserveCar} fullWidth classNames="build-primary-button build-buy-button">
                        <BnbLabel label={reserveLabel} />
                    </ButtonPrimary>
                )}
                <ButtonWithIcon hasIconLeft href={summaryStep.href}>
                    <Text.IconButton>
                        <BnbLabel label="reserveBackToSummary" />
                    </Text.IconButton>
                    <IconArrowLeftLong />
                </ButtonWithIcon>
            </Styles.ButtonWrapper>
        </Styles.Panel>
    );
};

export default ReservePanel;
